import features from './features/solidarity.features';
import components from './components/solidarity.components';
import common from './common/solidarity.common';

let solidarityModule = angular.module('solidarity', [
  common,
  features,
  components,
])

  .config(($translatePartialLoaderProvider) => {
    'ngInject';

    $translatePartialLoaderProvider.addPart('solidarity.module');
  })

  .name;

export default solidarityModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/solidarity.module.js